import PropTypes from 'prop-types'
import { FormControl } from 'baseui/form-control'
import SDFormControl from '@/shared/components/SDComponentsNewDesign/SDFormControl/SDFormControl'
import SDInput from '@/shared/components/SDComponentsNewDesign/SDInput/SDInput'
import useMeterInput from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/Fields/MeterInput/useMeterInput'
import PdlSearchButton from '@/containers/SubscriptionFormPageNew/Components/ElectricityMeter/PdlSearch/PdlSearchButton'
import getError from '@/containers/SubscriptionFormPageNew/getError'
import CopyEndEnhancer from '@/shared/components/SDComponentsNewDesign/CopyEndEnhancer/CopyEndEnhancer'
import { ELECTRICITY_METER_KEY } from '@/containers/SubscriptionFormPageNew/SubscriptionForm/Common/constants'

const MeterInput = ({ meterKey = ELECTRICITY_METER_KEY }) => {
  const {
    meterIdOnBlurHandler,
    meterSerialOnBlurHandler,
    pdlNo,
    meterSerialNumber,
    showMeterSerialNumber,
    meterIdLabel,
    lastSentDate,
    isEditable,
    meterStatus,
    showPdlSearchButton,
    meterIdMaxLength,
    errors,
    errorKey,
    t,
  } = useMeterInput({ meterKey })

  return (
    <>
      <FormControl error={getError(errorKey, errors)}>
        <>
          <SDInput
            disabled={isEditable === false || lastSentDate}
            onBlur={value => meterIdOnBlurHandler(value)}
            currentValue={pdlNo}
            label={meterIdLabel}
            placeholder={t('subscriptionForm:pdl_module.meter_id.placeholder')}
            maxLength={meterIdMaxLength}
            status={meterStatus}
            endEnhancer={<CopyEndEnhancer value={pdlNo} />}
            button={<PdlSearchButton hidden={!showPdlSearchButton} />}
          />
        </>
      </FormControl>
      <SDFormControl
        hidden={!showMeterSerialNumber}
        caption={t('subscriptionForm:pdl_module.meter_serial_number.caption')}
      >
        <SDInput
          disabled={isEditable === false || lastSentDate}
          onBlur={value => meterSerialOnBlurHandler(value)}
          currentValue={meterSerialNumber}
          label={meterSerialNumber ? t('subscriptionForm:pdl_module.meter_serial_number.label') : ''}
          placeholder={t('subscriptionForm:pdl_module.meter_serial_number.placeholder')}
          endEnhancer={<CopyEndEnhancer value={meterSerialNumber} />}
        />
      </SDFormControl>
    </>
  )
}

MeterInput.propTypes = {
  meterKey: PropTypes.string,
}

export default MeterInput
